import {Injectable}                          from '@angular/core';
import {TaskManagementDataProviderBasicfert} from './task-management-data-provider.basicfert';
import {TaskManagementDataProviderNfert}     from './task-management-data-provider.nfert';
import {TaskManagementDataProviderPsfert}    from './task-management-data-provider.psfert';
import {ITaskManagementDataProvider}         from './task-management-data-provider.interface';
import {Observable}                          from 'rxjs';
import {DriverStore}                         from '../../stores/docu/driver.store';
import {MachineStore}                        from '../../stores/docu/machine.store';
import {InstrumentStore}                     from '../../stores/docu/instrument.store';
import {LanguageStore}                       from '../../stores/translation/language.store';
import {GetRoundNumericPipe}                 from '../../ap-utils';
import {SettingsStore}                       from '../../stores/base-data/settings.store';
import {filter, map}                         from 'rxjs/operators';
import TaskManagementModule = Data.TaskManagement.TaskManagementModule;
import IInstrument = Data.DocuContext.Instrument.IInstrument;
import IMachine = Data.DocuContext.Machine.IMachine;
import IDriver = Data.DocuContext.Driver.IDriver;

@Injectable({providedIn: 'root'})
export class TaskManagementDataProviders {
  [module: number]: ITaskManagementDataProvider;

  public drivers$: Observable<IDriver[]>;
  public machines$: Observable<IMachine[]>;
  public instruments$: Observable<IInstrument[]>;

  constructor(basicFertDataProvider: TaskManagementDataProviderBasicfert,
              nFertDataProvider: TaskManagementDataProviderNfert,
              psFertDataProvider: TaskManagementDataProviderPsfert,
              driverStore: DriverStore,
              machineStore: MachineStore,
              instrumentStore: InstrumentStore,
              public languageStore: LanguageStore,
              public roundNumericPipe: GetRoundNumericPipe,
              public settingsStore: SettingsStore) {
    this[TaskManagementModule.GD_BasicFertilization] = basicFertDataProvider;
    this[TaskManagementModule.N_NFertilization] = nFertDataProvider;
    this[TaskManagementModule.PS_Fertilization] = psFertDataProvider;

    this.drivers$ = driverStore.Listen(s => s.data).pipe(
      filter(d => !!d),
      map(drivers => drivers.filter(driver => !driver.IsDeleted)));

    this.machines$ = machineStore.Listen(s => s.data).pipe(
      filter(d => !!d),
      map(machines => machines.filter(machine => !machine.IsDeleted)));

    this.instruments$ = instrumentStore.Listen(s => s.data).pipe(
      filter(d => !!d),
      map(instruments => instruments.filter(machine => !machine.IsDeleted)));
  }
}
